<template>
  <div>
    <div v-for="(item, index) in textArr" :key="index"
      >{{ item }} <br v-if="item == ''"
    /></div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      textArr: [],
    };
  },
  created() {
    if (this.text) {
      this.textArr = this.text.split("\n");
    }
  },
};
</script>